<div class="comp-container">
    <mat-tab-group class="custom-tab-group-2 main-white-panel" [(selectedIndex)]="selectedTabIndex">
        <mat-tab label="Ledger and Topic Configuration" [disabled]="true">
            <app-qubriux-loading *ngIf="isDataLoading" class="loading-container" [size]="45"></app-qubriux-loading>
            <div class="ledger-topic-container" *ngIf="!isDataLoading">
                <div class="ledger-list-container sp-cont">
                    <div class="d-flex g-0 height-fit-content bottom-margin-std">
                        <div class="step-text flex-grow-1">Ledger List</div>
                        <button class="loyalty-program-config-panel-continue-button primary-button" (click)="addLedger()">
                            Add Ledger
                        </button>
                    </div>
                    <div class="ledger-list">
                        <div class="row g-0 ledger" *ngFor="let ledger of getNotDeletedLedgerList();let i=index">
                            <div class="rc-values-container col-sm flex-grow-1 gx-3">
                                <label class="label-style">Ledger Name</label><span class="qb-imp-color">*</span>
                                <div class="rp-name-inp-container max-width-100" [id]="'ledgerName'+i">
                                    <input class="rp-name-inp" type="text" placeholder="Enter your ledger name" [(ngModel)]="ledger.ledgerName" maxlength="30" (keydown)="resetErrorState()" #inp>
                                    <div class="inp-text-left">{{inp.getAttribute('maxlength') - inp.value.length}} {{'SEGMENT_PAGE.CHAEACTER_LEFT' | i18nTranslate}}</div>
                                </div>
                            </div>
                    
                            <div class="basic-values-container col-sm gx-3">
                                <label class="label-style">Expire After</label><span class="qb-imp-color">*</span>
                                <div class="d-flex">
                                    <div class="d-flex me-4 padding-top-8">
                                        <mat-checkbox class="me-2" color="primary" [checked]="ledger.isNeverExpiry" (change)="checkExpiry(ledger)">
                                        </mat-checkbox>
                                        <div>
                                            Never
                                        </div>
                                    </div>
                                    <div class="d-flex flex-grow-1">
                                        <mat-checkbox class="me-2 padding-top-8" color="primary" [checked]="!ledger.isNeverExpiry" (change)="checkExpiry(ledger)">
                                        </mat-checkbox>
                                        <div class="rp-name-inp-container rule-value" [id]="'expiryDays'+i">
                                            <input class="rp-name-inp" type="number" placeholder="eg. 2" [(ngModel)]="ledger.expiryDays" (keydown)="numberInputHandler($event,7,'number')"
                                            (keyup)="resetErrorState()" #inp2 maxlength="7" min="0" max="9999999" [disabled]="ledger.isNeverExpiry">Days
                                            <div class="inp-text-left">{{inp2.getAttribute('maxlength') - inp2.value.length}} {{'SEGMENT_PAGE.CHAEACTER_LEFT' | i18nTranslate}}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                    
                            <div class="rc-values-container col-sm-3 gx-3">
                                <label class="label-style">Ledger Priority</label><span class="qb-imp-color">*</span>
                                <span class="qb-i-div"
                                    style="margin-top: 0px;"
                                    popoverclass="qb-my-custom-class"
                                    placement="left"
                                    [ngbPopover]="popRuleRank"
                                    triggers="mouseenter:mouseleave"
                                    >i
                                </span>
                                <ng-template #popRuleRank>
                                    <div class="qb-ng-template-text">lower the number higher the priority (Ranking System)</div>
                                </ng-template>
                                <div class="rp-name-inp-container" [id]="'priority'+i">
                                    <mat-select [(ngModel)]="ledger.priority" placeholder="Select a rank" (ngModelChange)="resetErrorState()">
                                        <mat-option *ngFor="let number of getRankNumberArray();" [value]="number" selected>{{number}}</mat-option>
                                    </mat-select>
                                </div>
                            </div>
                            <div class="rc-values-container col-sm-2" *ngIf="getNotDeletedTopicList().length>0">
                                <label class="label-style">Ledger Topic</label>
                                <div class="rp-name-inp-container" [id]="'ledgerTopicName'+i" >
                                    <mat-select [(ngModel)]="ledger.topicName" placeholder="Select Topic" (ngModelChange)="resetErrorState();checkAndAddTopicToLedger(ledger)">
                                        <mat-option *ngFor="let topic of getNotDeletedTopicList();" [value]="topic.topicName" selected>{{topic.topicName}}</mat-option>
                                    </mat-select>
                                </div>
                            </div>
                            
                            <button class="delete-button delete-2 button-hover-effect" title="Delete Ledger" (click)="deleteLedger(ledger.ledgerName)" *ngIf="getNotDeletedLedgerList().length>1">
                                <span class="material-symbols-outlined">
                                    delete
                                    </span>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="topic-list-container sp-cont">
                    <div class="d-flex g-0 height-fit-content">
                        <div class="step-text flex-grow-1">Topic List</div>
                        <button class="loyalty-program-config-panel-continue-button primary-button" (click)="showTopicCreationUi(true)" *ngIf="!isTopicCreationUiVisible">
                            Add Topic
                        </button>
                    </div>
                    <div class="row g-0" *ngIf="!isTopicCreationUiVisible" class="topic-list">
                        <div *ngIf="getNotDeletedTopicList().length==0" class="no-topics">
                            No topic added 
                        </div>
                        <div *ngFor="let topic of getNotDeletedTopicList();let i=index" class="topic">
                            <div>
                                {{topic.topicName}}
                            </div>
                            <div class="material-symbols-outlined topic-delete" title="Delete Topic" (click)="deleteTopic(topic.topicName)">
                                close
                            </div>
                        </div>
                    </div>
                    <div class="row g-0 topic-create col-sm-3"  *ngIf="isTopicCreationUiVisible">
                        <div class="rc-values-container col-sm flex-grow-1 ">
                            <label class="label-style">Topic Name</label><span class="qb-imp-color">*</span>
                            <div class="rp-name-inp-container max-width-100" [id]="'topicName'+i">
                                <input class="rp-name-inp" type="text" placeholder="Enter your topic name" [(ngModel)]="tempTopic.topicName" maxlength="30" (input)="showTopicNameError=false" #inp11>
                                <div class="inp-text-left">{{inp11.getAttribute('maxlength') - inp11.value.length}} {{'SEGMENT_PAGE.CHAEACTER_LEFT' | i18nTranslate}}</div>
                            </div>
                        </div>
                        <small *ngIf="showTopicNameError" class="error-text">Topic with this name already exists</small>
                        <div class="d-flex">
                            <button class="primary-button button-hover-effect me-1" (click)="addTopic()">Save</button>
                            <button class="secondary-button button-hover-effect" (click)="showTopicCreationUi(false)">Cancel</button>
                        </div>
                    </div>
                </div>
            </div>
        </mat-tab>
        <mat-tab label="Not Allowed Ledgers" [disabled]="true">
            <app-qubriux-loading *ngIf="isDataLoading" class="loading-container" [size]="45"></app-qubriux-loading>
            <div class="ledger-list margin-left-std" *ngIf="!isDataLoading">
                <div class="row d-flex align-items-center g-0 bottom-margin-std top-margin-std">
                    <div class="lb-text">
                        Coupon Code
                    </div>
                    <mat-select [(ngModel)]="notAllowedLedgerConfig.couponCode.notAllowedLedgers" placeholder="Select Ledgers" class="sp-select-2" multiple>
                        <mat-option *ngFor="let ledger of ledgerList" [value]="ledger.id">
                        {{ ledger.ledgerName }}
                        </mat-option>
                    </mat-select>
                </div>
                <div class="row d-flex align-items-center g-0 bottom-margin-std">
                    <div class="lb-text">
                        Thomcoins earning
                    </div>
                    <mat-select [(ngModel)]="notAllowedLedgerConfig.thomcoinsEarning.notAllowedLedgers" placeholder="Select Ledgers" class="sp-select-2" multiple>
                        <mat-option *ngFor="let ledger of ledgerList" [value]="ledger.id">
                        {{ ledger.ledgerName }}
                        </mat-option>
                    </mat-select>
                </div>
                <div class="row d-flex align-items-center g-0 bottom-margin-std">
                    <div class="lb-text">
                        Thomcoins redemption
                    </div>
                    <mat-select [(ngModel)]="notAllowedLedgerConfig.thomcoinsRedemption.notAllowedLedgers" placeholder="Select Ledgers" class="sp-select-2" multiple>
                        <mat-option *ngFor="let ledger of ledgerList" [value]="ledger.id">
                        {{ ledger.ledgerName }}
                        </mat-option>
                    </mat-select>
                </div>
                <div class="row d-flex align-items-center g-0 bottom-margin-std">
                    <div class="lb-text">
                        Delivery Charge
                    </div>
                    <mat-select [(ngModel)]="notAllowedLedgerConfig.delivery.notAllowedLedgers" placeholder="Select Ledgers" class="sp-select-2" multiple>
                        <mat-option *ngFor="let ledger of ledgerList" [value]="ledger.id">
                        {{ ledger.ledgerName }}
                        </mat-option>
                    </mat-select>
                </div>
                <!-- <div class="row d-flex align-items-center g-0 bottom-margin-std">
                    <div class="lb-text">
                        Cashback
                    </div>
                    <mat-select [(ngModel)]="notAllowedLedgerConfig.cashback.notAllowedLedgers" placeholder="Select Ledgers" class="sp-select-2" multiple>
                        <mat-option *ngFor="let ledger of ledgerList" [value]="ledger.id">
                        {{ ledger.ledgerName }}
                        </mat-option>
                    </mat-select>
                </div>
                <div class="row d-flex align-items-center g-0 bottom-margin-std">
                    <div class="lb-text">
                        Loyalty Programs
                    </div>
                    <mat-select [(ngModel)]="notAllowedLedgerConfig.loyaltyPrograms.notAllowedLedgers" placeholder="Select Ledgers" class="sp-select-2" multiple>
                        <mat-option *ngFor="let ledger of ledgerList" [value]="ledger.id">
                        {{ ledger.ledgerName }}
                        </mat-option>
                    </mat-select>
                </div> -->
            </div>
        </mat-tab>
      </mat-tab-group>
    <div class="flex form-flow-buttons margin-0 ps-2 pb-1"> 
        <button class="loyalty-program-config-panel-discard-button primary-button" (click)="discard()" >
            {{'SEGMENT_PAGE.DISCARD' | i18nTranslate}}
        </button>
        <button class="primary-button margin-right-20" (click)="saveAndExitBasedOnTab()" >
            {{'SEGMENT_PAGE.SAVE_EXIT' | i18nTranslate}}
        </button>
        <button class="loyalty-program-config-panel-save-and-exit-button primary-button" (click)="saveLedgerAndTopicConfig(true)" *ngIf="selectedTabIndex == 0">
            {{'SEGMENT_PAGE.CONTINUE' | i18nTranslate}}
        </button>
        <button class="loyalty-program-config-panel-save-and-exit-button primary-button" (click)="saveNotAllowedLedgerConfig(true)" *ngIf="selectedTabIndex == 1">
            Back
        </button>
    </div>
</div>



    


    
   
    
